module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-ThIt.1d3ecb8.woff";